import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { exportToCSV } from "@/utils/export-to-csv";
import { Box } from "rizzui";
import { serviceListColumns } from "./columns";
import { Service } from "@/types"; // Update import to Service type
import { useEffect } from "react";

type ServiceListTableProps = {
    services: Service[]; // Change to Service array
    refresh(): void;
};

export default function ServiceListTable({ services = [], refresh }: ServiceListTableProps) { // Default to empty array
    const { table, setData } = useTanStackTable<Service>({
        tableData: services, // Use services array directly
        columnConfig: serviceListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                    table.resetRowSelection();
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                    table.resetRowSelection();
                },
            },
            enableColumnResizing: false,
        },
    });

    useEffect(() => {
        setData(services); // Use services array directly
    }, [services, setData]);

    const selectedData = table
        .getSelectedRowModel()
        .rows.map((row) => row.original);

    function handleExportData() {
        exportToCSV(
            selectedData,
            "Id,Name,SubTitle,Description,Image,Icon,CreatedDate,CreatedUser", // Update CSV headers
            `Services_${selectedData.length}`, // Update file name prefix
        );
    }

    return (
        <Box>
            <Table
                table={table}
                variant="modern"
                classNames={{
                    container: "border border-muted rounded-md",
                    rowClassName: "last:border-0",
                }}
            />
            <TableFooter table={table} onExport={handleExportData} />
            <TablePagination table={table} className="py-4" />
        </Box>
    );
}
